module.exports = __webpack_public_path__ + "static/media/cvv.d9f708f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/cvv.svg
// module id = 633
// module chunks = 0